
import React from 'react';
import { Button } from '@/components/ui/button';
import { SaveIcon, Loader2 } from 'lucide-react';

interface ProfileFormFooterProps {
  isUpdating: boolean;
}

const ProfileFormFooter = ({ isUpdating }: ProfileFormFooterProps) => {
  return (
    <div className="pt-6 space-y-4">
      <Button 
        type="submit" 
        disabled={isUpdating} 
        className="w-full flex items-center justify-center gap-2"
      >
        {isUpdating ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Updating Profile...</span>
          </>
        ) : (
          <>
            <SaveIcon className="h-4 w-4" />
            <span>Save Profile</span>
          </>
        )}
      </Button>
      {isUpdating && (
        <p className="text-center text-sm text-muted-foreground">
          Your profile is being updated. This may take a moment...
        </p>
      )}
    </div>
  );
};

export default ProfileFormFooter;
